module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('PeriodicalUpdater', {
		configure: function(options) {
			this.registerOptions('', {
				started: false,
				updateTime: 100000,
				loadOnStart: false,
			});

			this.callParent('configure', arguments);
		},

		init: function() {
				this.visual = false;
				this.timerId = 0;
		},

		todo: function() {},

		startUpdate: function() {
			if (fox.isEmpty(this.timerId)) {
				if (this.getOption('loadOnStart')) {
					this.todo();
				};

				this.timerId = setInterval(fox.bind(this.todo, this), fox.cookie.get('updateTimeout') || this.getOption('updateTime'));
				this.setOption('started', true);
			};
		},
		
		stopUpdate: function() {
				if (!fox.isEmpty(this.timerId)) {
						clearInterval(this.timerId);
						this.timerId = 0;
						this.setOption('started', false);
				}
		},

		isStarted: function() {
			return this.getOption('started');
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/periodicalUpdater.js
// module id = 457
// module chunks = 4